import { TabProps, TagsAndMetadataTabs } from "./types";

export const getTabProps = (tab: TagsAndMetadataTabs): TabProps => ({
  id: `module-tab-${tab}`,
  "aria-controls": `module-tabpanel-${tab}`,
});
